<a class="card-block copo-clickable" mat-ripple [routerLink]="displayedOfferLine.path">

	<div class="order-tracking-list-card-header">
		<span class="order-tracking-list-card-header-title">{{ displayedOfferLine.rfqRef }}</span>
		<span
			class="order-tracking-list-card-header-ton"
			[matTooltip]="displayedOfferLine.quantity ? (displayedOfferLine.quantity | copoNumber:'weight':'t' ) : underscore"
		>{{ displayedOfferLine.quantity ? (displayedOfferLine.quantity | copoNumber:'weight':'t' ) : underscore }}</span>
	</div>
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>eoffer.status</span>
			<span
				class="order-card-value"
				[matTooltip]="displayedOfferLine.status | translate"
			>{{ displayedOfferLine.status | translate }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>eoffer.period</span>
			<span
				class="order-card-value"
				[matTooltip]="displayedOfferLine.period"
			>{{ displayedOfferLine.period }}</span>
		</div>
	</div>
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>eoffer.steelGrade</span>
			<span
				class="order-card-value"
				[matTooltip]="displayedOfferLine.steelGrade"
			>{{ displayedOfferLine.steelGrade }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>eoffer.dimension.mm</span>
			<span
				class="order-card-value"
				[matTooltip]="getDimension() "
			>{{ getDimension() }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>eoffer.price</span>
			<span
				class="order-card-value"
				[matTooltip]="displayedOfferLine.price ? (displayedOfferLine.price.amount | copoNumber:'amount':displayedOfferLine.price.currency) : underscore"
			>{{ displayedOfferLine.price ? (displayedOfferLine.price.amount | copoNumber:'amount':displayedOfferLine.price.currency) : underscore }}</span>
		</div>
	</div>
</a>
